/*
 * @Author: LH
 * @Date:   2018-08-11 23:34:51
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-13 16:39:16
 */
import {
  service
} from '@/utils/request'

export default {
  //获取学习卡列表
  getDataList() {
    return service({
      url: '/cloud/activity/v1/study/card/listAll',
      method: 'get',
    })
  },
  //增加学习卡
  addStudyCardApi: (data) => {
    return service({
      url: '/cloud/activity/v1/study/card/create',
      method: 'post',
      data: data
    })
  },
  //获取详情
  findById: (path) => {
    return service({
      url: '/cloud/activity/v1/study/card/findById' + path,
      method: 'get',
    })
  },
  //编辑学习卡
  updateStudyCardApi: (data) => {
    return service({
      url: '/cloud/activity/v1/study/card/update',
      method: 'post',
      data: data
    })
  },
  //学习卡领取明细
  getReceivedDetail: (params) => {
    return service({
      url: '/cloud/activity/v1/study/card/receiveDetailPageList',
      method: 'get',
      params: params
    })
  },
  //获取小程序学习卡页面二维码
  getMiniAppQRcode: (params) => {
    return service({
      url: '/cloud/education/miniapp/miniappQRCode',
      method: 'post',
      params: params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/studyCard.js